import React from "react"

// Shown in place of the Local / Rental booking form while those products are in
// "coming soon" mode (see config/launch.js). Keeps the rider on a live product
// (outstation) instead of a dead end. No fabricated claims.
const COPY = {
  local: {
    title: "Local rides are coming soon",
    line: "We are putting the finishing touches on in-city and airport transfers. Right now you can book outstation cabs across India.",
  },
  rental: {
    title: "Hourly rentals are coming soon",
    line: "We are finalising our hourly rental packages. Right now you can book outstation cabs across India.",
  },
}

const ComingSoon = ({ product = "local", onSwitchToOutstation }) => {
  const c = COPY[product] || COPY.local
  return (
    <div className="w-[87%] max-[600px]:w-[95%] mx-auto py-7 md:py-9 text-center">
      <div className="mx-auto mb-4 w-14 h-14 rounded-2xl bg-[#eef6f5] border border-[#d4edec] flex items-center justify-center">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#21A5A0" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
        </svg>
      </div>
      <div className="inline-block mb-3 text-[11px] font-black uppercase tracking-[0.18em] text-[#E05A49] bg-[#fdeeeb] border border-[#f6d5cf] rounded-full px-3 py-1">
        Coming soon
      </div>
      <h3 className="text-[19px] md:text-[21px] font-black text-[#1a1a1a] mb-2">{c.title}</h3>
      <p className="text-[13px] md:text-[13.5px] leading-relaxed text-[#5b6b66] max-w-[430px] mx-auto mb-5">{c.line}</p>
      <button
        type="button"
        onClick={onSwitchToOutstation}
        className="inline-flex items-center gap-2 bg-[#21A5A0] hover:bg-[#178f89] text-white font-bold text-[14px] px-5 py-3 rounded-xl transition-colors shadow-[0_4px_14px_rgba(33,165,160,0.3)]"
      >
        Book an outstation cab
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
        </svg>
      </button>
      <div className="mt-4 text-[12.5px] text-[#8a9793]">
        Need one now? Call <a href="tel:+918052080501" className="font-bold text-[#21A5A0]">+91 80520 80501</a>
      </div>
    </div>
  )
}

export default ComingSoon
